import React from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import boxImg from "../../../assets/images/moving/box2.jpg";
import "./Box.css";

const Box = ({ items, onChange }) => {
  // const displayExplain = () => {
  //   const cardboardExplain = document.querySelector(".cardboardExplain");
  //   if (cardboardExplain.style.color === "gray") {
  //     cardboardExplain.style.color = "transparent";
  //     cardboardExplain.style.backgroundColor = "transparent";
  //   } else {
  //     cardboardExplain.style.color = "gray";
  //     cardboardExplain.style.backgroundColor = "white";
  //   }
  // };

  return (
    <div>
      <div className="boxPick">
        <Row className="row">
          <Form.Group as={Col} className="mb-3" controlId="formBasicBox">
            <Form.Label className="fw-semibold mb-2">מספר קרטונים</Form.Label>
            <Form.Select
              aria-label="Default select example"
              onChange={onChange}
              name="box"
              required
            >
              {/*TODO Разобраться почему в запрос попадают товары с botId = Null*/}
              <option value="" disabled>
               נא לבחור
              </option>
              {items?.length
                ? items
                  .filter((item) => item.botId)
                  .sort((a, b) => {
                    // Extract the numbers from the titles
                    const aNum = parseInt(a.title.match(/\d+/));
                    const bNum = parseInt(b.title.match(/\d+/));
                    // Compare the numbers
                    return aNum - bNum;
                  })
                  .map((item, key) => (
                    <option key={`box_item_${key}`} value={item.entityId}>
                      {item.title}
                    </option>
                  ))
                : ""}
            </Form.Select>
          </Form.Group>
          <div className="boxes col">
            <img className="boxImg" src={boxImg} alt="aa" />
            <img className="boxImg" src={boxImg} alt="aa" />
          </div>
        </Row>
        {/* <div>*גודל קרטון מקסימלי: 50/50/65 ס"מ</div> */}
        {/* <div className='mb-3'>*עלות כל קרטון נוסף מעבר למספר הנבחר: ₪15 </div> */}
        {/* <div className='mb-3'>*עלות ההובלה לא כוללת אספקת קרטונים, למעט בהזמנת שירותי אריזה </div> */}
      </div>
    </div>
  );
};

export default Box;
